/**
 * Token storage for both webapps.
 *
 * `auth-token` is this app's own key and the source of truth. `user` mirrors the zustand-persist
 * envelope that frozen `apps/main` hydrates its user store from, so a single sign-in also
 * authenticates the old webapp. Both apps must be served from the same origin for the mirror to be
 * visible — `localStorage` is origin-scoped.
 *
 * @deprecated The `user` mirror is temporary: delete it with `apps/main`, together with the
 * backend's LEGACY-WEBAPP-TOKEN session mirroring.
 */

import type { TokenStorage } from "@eisox/auth";

const AUTH_TOKEN_KEY = "auth-token";

/** `name` of the persist store in `apps/main/src/stores/user/user.ts`, which holds only the token. */
const LEGACY_USER_STORE_KEY = "user";
const LEGACY_USER_STORE_VERSION = 1;

const authTokenStorage: TokenStorage = {
  get: () => localStorage.getItem(AUTH_TOKEN_KEY),
  set: token => {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(
      LEGACY_USER_STORE_KEY,
      JSON.stringify({ state: { token }, version: LEGACY_USER_STORE_VERSION }),
    );
  },
  clear: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(LEGACY_USER_STORE_KEY);
  },
};

export { authTokenStorage };
